import React from 'react';
import { useEffect, useState, useRef } from 'react';
import LoadingIcon from '../LoadingIcon';

export default function ({
    searchValue,
    handleInputChange,
    placeholderText,
    setSearchValue,
    isLoading = false,
    isFetching = false,
}) {


    const searchField = useRef(null);
    const onKeyUp = (e) => {
        if (e.key === 'Enter') {
            e.preventDefault();
        }
    };

    const onChange = (e) => {
        if (searchValue !== e.target.value) {
            handleInputChange(e.target.value);
        }
    };

    /**
     * When the searchValue changes in the parent component, update the input value
     */
    useEffect(() => {
        if (searchField.current.value !== searchField) {
            searchField.current.value = searchValue;
        }
    }, [searchValue])

    return (
        <div
            className="border flex flex-row justify-between items-center"
            style={{ height: '58px' }}
        >
            <input
                type="text"
                name="searchInputField"
                onChange={onChange}
                onKeyUp={onKeyUp}
                className="w-full h-full ps-4"
                placeholder={placeholderText}
                autoComplete="false"
                required={true}
                ref={searchField}
            />
            <div className="flex flex-row justify-between items-center">
                {searchValue && searchValue.length > 0 && (
                    <div
                        className="p-3 flex flex-row items-center cursor-pointer"
                        onClick={() => {
                            setSearchValue('');
                        }}
                    >
                        <i className="mio">close</i>
                    </div>
                )}
                {isLoading || isFetching ? (
                    <div className="px-3">
                        <LoadingIcon></LoadingIcon>
                    </div>

                ) : (
                    <button
                        type="submit"
                        className="p-3 flex flex-row items-center cursor-pointer">
                        <i className="mio">search</i>
                    </button>
                )}
            </div>
        </div>
    );
}
